// MasterPlanMap.jsx
import React, { useEffect, useRef, useMemo, useState } from "react";
import { loadModules } from "esri-loader";
import { useDispatch, useSelector } from "react-redux";
import { setIsBufferWidth, setIsSidebar } from "../store/slice/currentStageSlice";

import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";



const MASTER_PLAN_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";
const PROPERTY_URL = "https://urbangis.mp.gov.in/server/rest/services/Hosted/property_info_209/FeatureServer/1";
const ADMIN_LAYER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const layerGroups = {
    admin: [1, 3]
};

const MasterPlanMap = ({
    selectedTown,
    selectedLandUse,
    selectedType,
    townToUlb,
    onPropertyFeaturesChange, isWidth, isByDefaultActive, isScreenSize, isTableMaximized, isTableView,
    isRelationId, propertyFeatures
}) => {
    const viewDiv = useRef(null);
    const viewRef = useRef(null);
    const propertyLayerRef = useRef(null);
    const masterSubRef = useRef(null);
    const highlightLayerRef = useRef(null)
    const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
    const { isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
    const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
    const [view, setView] = useState(null);
    const dispatch = useDispatch();
 const legendWidgetRef = useRef(null);


    useEffect(() => {
        let viewInstance;

        loadModules([
            "esri/Map",
            "esri/views/MapView",
            "esri/layers/MapImageLayer",
            "esri/layers/FeatureLayer",
            "esri/geometry/geometryEngine",
               "esri/layers/GraphicsLayer",
        ]).then(([Map, MapView, MapImageLayer, FeatureLayer, geometryEngine,GraphicsLayer]) => {
            const map = new Map({ basemap: "topo-vector" });
            viewInstance = new MapView({
                container: viewDiv.current,
                map,
                center: [77.4, 23.25],
                zoom: 6
            });
            viewRef.current = viewInstance;
            setView(viewInstance)


// code for Legend
  view.ui.add(new Search({ view: view }), "top-left");
        view.ui.add(new Home({ view: view }), "top-left");
        view.ui.add(new Zoom({ view: view }), "top-left");
        view.ui.add(new Expand({ view: view, content: new BasemapGallery({ view: view }) }), "top-right");
        view.ui.add(new Locate({ view: view, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-right");
        view.ui.add(new ScaleBar({ view: view }), "bottom-right");

        view.when(() => {
            const printWidget = new Print({
                view: view,
                printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
            });

            const expandPrint = new Expand({
                view: view,
                content: printWidget
            });

            view.ui.add(expandPrint, "top-right");

            // ✅ Add and attach legend
            const legendWidget = new Legend({
                view: view,
                style: "classic"
            });

            const legendExpand = new Expand({
                view: view,
                content: legendWidget,
                expanded: false
            });

            view.ui.add(legendExpand, "top-right");
            legendWidgetRef.current = legendWidget;
        });

        //  legend  layerList

        const layerList = new LayerList({
            view: view
        });

        const expand = new Expand({
            view: view,
            content: layerList,
            expanded: false
        });

        view.ui.add(expand, "top-right");


// code for leged


            const masterMIL = new MapImageLayer({ url: MASTER_PLAN_URL });
            map.add(masterMIL);

            // Add admin layer
            const adminLayer = new MapImageLayer({
                url: ADMIN_LAYER_URL,
                sublayers: layerGroups.admin.map(id => ({
                    id,
                    title: `Admin Layer ${id}`,
                    visible: true
                }))
            });
            map.add(adminLayer);

            masterMIL.when(() => {
                const masterSub = masterMIL.findSublayerById(3);
                if (masterSub) {
                    masterSub.definitionExpression = "1=0";
                    masterSubRef.current = masterSub;
                }
            });




            // Ensure Master Plan sublayer 3 is ON by default
            masterMIL.when(() => {
                const masterSub = masterMIL.findSublayerById(3);
                if (masterSub) {
                    masterSub.definitionExpression = "1=1"; // show everything initially
                    masterSubRef.current = masterSub;
                }
            });

            const propertyLayer = new FeatureLayer({
                url: PROPERTY_URL,
                outFields: ["*"],
                visible: true,
                definitionExpression: "1=0"
            });
            map.add(propertyLayer);
            propertyLayerRef.current = propertyLayer;


            const highlightLayer = new GraphicsLayer({
                title: "Highlight Layer",
                listMode: "hide" // optional, hides from LayerList widget
            });
            map.add(highlightLayer); // ✅ Add this last
            highlightLayerRef.current = highlightLayer;


            map.reorder(highlightLayer, map.layers.length - 1);

            // Cleanup function
            return () => {
                if (viewInstance) {
                    viewInstance.destroy();
                }
            };
        });

        // Cleanup on component unmount
        return () => {
            if (viewInstance) {
                viewInstance.destroy();
            }
        };
    }, []);


    useEffect(() => {
        if (selectedTown && viewRef.current && masterSubRef.current) {
            handleRun();
        }
    }, [selectedTown, selectedLandUse, selectedType]);




    useEffect(() => {
        const handleResize = () => {
            setIsScreenSize1(window.innerWidth <= 991)
        };
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    // Handle updates when props change
    // useEffect(() => {
    //     if (selectedTown && selectedLandUse && viewRef.current && propertyLayerRef.current && masterSubRef.current) {
    //         handleRun();
    //     }
    // }, [selectedTown, selectedLandUse, selectedType]);





    const handleRowClick = async (relationId) => {
        const [Graphic] = await loadModules(["esri/Graphic"]);

        const selectedFeature = propertyFeatures.find(
            (f) => f.attributes.relation_id === relationId
        );

        if (selectedFeature && view && highlightLayerRef.current) {
            // Zoom to the feature
            await view.goTo({
                target: selectedFeature.geometry,
                zoom: 20
            });

            // Clear previous highlights
            highlightLayerRef.current.removeAll();

            // Add red border highlight (transparent fill)
            const highlightGraphic = new Graphic({
                geometry: selectedFeature.geometry,
                symbol: {
                    type: "simple-fill",
                    color: [0, 0, 0, 0], // Transparent fill
                    outline: {
                        color: [255, 0, 0, 1], // Red border
                        width: 3
                    }
                }
            });

            highlightLayerRef.current.add(highlightGraphic);
        }
    };






    const handleRun = async () => {
        const [FeatureLayer, geometryEngine] = await loadModules([
            "esri/layers/FeatureLayer",
            "esri/geometry/geometryEngine"

        ]);
        const masterFL = new FeatureLayer({ url: `${MASTER_PLAN_URL}/3` });

        // Build WHERE clause
        let where = `town_name='${selectedTown}'`;
        if (selectedLandUse) {
            where += ` AND land_use='${selectedLandUse}'`;
        }

        // Query Master Plan
        const mpQuery = masterFL.createQuery();
        mpQuery.returnGeometry = true;
        mpQuery.where = where;
        const mpFS = await masterFL.queryFeatures(mpQuery);

        if (!mpFS.features.length) {
            masterSubRef.current.definitionExpression = "1=0";
            propertyLayerRef.current.definitionExpression = "1=0";
            onPropertyFeaturesChange([]);
            return;
        }

        // Filter sublayer on town/landuse
        masterSubRef.current.definitionExpression = where;

        // Get extent of town/landuse
        const unionGeom = mpFS.features.length > 1
            ? geometryEngine.union(mpFS.features.map(f => f.geometry))
            : mpFS.features[0].geometry;

        // Zoom to town
        if (viewRef.current) {
            await viewRef.current.goTo(unionGeom.extent.expand(0.8));
        }
        // zoom on property 




        // Query properties inside this area
        const propQuery = propertyLayerRef.current.createQuery();
        propQuery.returnGeometry = true;
        propQuery.geometry = unionGeom;
        propQuery.spatialRelationship = "intersects";
        propQuery.where = `ulb_cd='${townToUlb.current[selectedTown]}'`;

        const propFS = await propertyLayerRef.current.queryFeatures(propQuery);

        if (!propFS.features.length) {
            propertyLayerRef.current.definitionExpression = "1=0";
            onPropertyFeaturesChange([]);
            return;
        }

        // Filter by type
        let filtered = propFS.features;
        if (selectedType) {
            filtered = filtered.filter(f =>
                f.attributes.landusetype?.toUpperCase().trim() === selectedType.toUpperCase()
            );
        }

        // Apply filter on property layer
        const oidField = propertyLayerRef.current.objectIdField;
        const ids = filtered.map(f => f.attributes[oidField]);
        propertyLayerRef.current.definitionExpression = ids.length
            ? `${oidField} IN (${ids.join(",")})`
            : "1=0";

        // Zoom to filtered properties if available
        if (filtered.length && viewRef.current) {
            try {
                const propUnion = filtered.length > 1
                    ? geometryEngine.union(filtered.map(f => f.geometry))
                    : filtered[0].geometry;
                await viewRef.current.goTo(propUnion.extent.expand(1.2));
            } catch (err) {
                console.error("Zoom failed:", err);
            }
        }

        onPropertyFeaturesChange(filtered);
    };



    console.log("isToolHeightisToolHeight-map", isToolHeight)
    console.log("isTableMaximized-map", isTableMaximized)
    console.log("isTableViewisTableView", isTableView)
    console.log("")

    const calculatedHeight = useMemo(() => {
        const hasFeatureTableData = setFeatureTable?.length > 0;
        if (isWidth && isByDefaultActive) {
            return "calc(100vh - 78px)"; // Adjust height as needed
        }


        if (isWidth) {
            return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
        }
        if (isWidth) {
            return "calc(100vh - 78px)"
        }
        if (!isWidth && hasFeatureTableData) {
            return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
        }
        if (!isWidth && hasFeatureTableData && isByDefaultActive) {
            return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
        }
        if (!isToolHeight && isTableView) {
            return "calc(100vh - 455px)"
        }

        if (isToolHeight && isTableView) {
            return "calc(100vh - 360px)"
        }

        if (!isToolHeight) {
            return "calc(100vh - 210px)"
        }
        return "calc(100vh - 109px)";
    }, [isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight, isTableView]);


    // const calculatedHeight = useMemo(() => {
    //     const hasFeatureTableData = setFeatureTable?.length > 0;
    //     if (isWidth && isByDefaultActive) {
    //         return "calc(100vh - 78px)"; // Adjust height as needed
    //     }


    //     if (isWidth) {
    //         return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    //     }
    //     if (isWidth) {
    //         return "calc(100vh - 78px)"
    //     }
    //     if (!isWidth && hasFeatureTableData) {
    //         return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
    //     }
    //     if (!isWidth && hasFeatureTableData && isByDefaultActive) {
    //         return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
    //     }
    //     if(isToolHeight && isTableMaximized){
    //         return  "calc(100vh - 210px)"
    //     }
    //     // if (isBufferWidth && isToolHeight) {
    //     //     return "calc(100vh - 110px)"
    //     // }
    //     // if (!isTableMaximized) {
    //     //     return "calc(100vh - 425px)"
    //     // }
    //     // if(isTableMaximized && isTableMaximized){
    //     //     return "calc(100vh - 425px)"
    //     // } 

    //     return "calc(100vh - 109px)";
    // }, [isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight, isTableMaximized]);

    const handleToggleBufferWidth = () => {
        dispatch(setIsBufferWidth(!isBufferWidth));
    };
    const handleToggleBufferLeft = () => {
        dispatch(setIsSidebar(!isSideBar));
    };


    return (
        <div className="position-relative">
<p> MAster Plan </p>

           
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    height: calculatedHeight,
                    // height: "450px",
                    // border: "4px solid #f39945ff",
                    borderRadius: "4px"
                }}
                ref={viewDiv}>
            </div>
            {currentStageValue === 0 ? "" :
                <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
                    <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
                        <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                    </div>
                </div>
            }
            {currentStageValue === 0 ? "" :
                <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
                >
                    <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
                        <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                    </div>
                </div>
            }
        </div>
    )


};

export default MasterPlanMap;